import React from "react";
import aideRefuse from '../img/non-css.png';
import alert from '../img/alert.png';
import logo from "../img/logo-bleu.webp";
import Telephone from './telephone.js';

/**
 * Custom component  for displaying negative results .
 * 
 * @param {*} props 
 * @returns JSX
 */
export default function NegativeResult (props) {
    const droit= props.droit;
	return <><div className="inner-container">
		<div className="result-image">
			<img src={aideRefuse}
			  alt="Aide trouvé"
			  className='result-img'
			/>
		</div>
		<div className="result-info">
            <h4>Malheureusement,</h4>
			<div>
              <p>
                d'après les informations que vous avez saisies, vous ne pouvez pas prétendre
                <br />
                à la <span class="font-bold">Complémentaire Santé Solidaire</span>
              </p>

			  <div className="warning d-flex">
				<div>
				<img src={alert} alt="Attention" />
				</div>
				<div className="warning-text">
					<span>Attention, la simulation vous informe mais n'a aucune valeur officielle.</span>
				</div>
				
			  </div>
			  <p className="b-link font-bold"></p>
			  <Telephone/>
			  <div className="restart-btn-container">
				<button className='button active restart' onClick={props.restart}>Recommencer</button>
			  </div>
			  <p className="result-info-text">Vous avez certainement droit à d'autres aides ! Effectuez gratuitement une simulation globale sur plus de 300 dispositifs pour le savoir.</p>
				<div className="simulation-btn-container">
				<a className='b-link' 
					href="https://www.aide-sociale.fr/questionnaire-steps/"
					target="_blank">
					<button className="button">Simulez vos droits</button>
				</a>
				</div>
                <a className="c-link font-bold" target="_blank" href="https://www.aide-sociale.fr/comparatif-mutuelle-sante/">
                    Où comparer les prix des mutuelles ?
                </a>
            </div>
		</div>

	</div>
		<div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
	</>;
}